module.exports = __WEBPACK_EXTERNAL_MODULE__anthropic_ai_sdk_a08f51c8__;